import React, { useEffect, useState } from "react";

/**
 *
 * @param label the default text
 * @param options array of options
 * @param select callback function
 * @param remove optional boolean to display icon to reset selector
 * @returns a dropdown with the passed options
 */
function Dropdown(props) {
  const {
    label,
    options,
    select,
    disable,
    remove = true,
    preSelect = null,
    fieldToDisplay = "name",
    fixedLabel = false,
    extraBtnCss
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [optionSelected, setOptionSelected] = useState(label);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSelection = (option) => {
    setOptionSelected(option[fieldToDisplay]);
    select(option);
    setIsOpen(false);
  };

  useEffect(() => {
    if (options !== null && preSelect !== null) {
      let preSelected = options.filter((o) => o.id === preSelect.id);
      setTimeout(() => {
        if (preSelected.length > 0) {
          handleSelection(preSelected[0]);
        }
      }, 1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, preSelect]);

  const handleReset = () => {
    select(null);
    setOptionSelected(label);
  };

  return (
    <div className="dd-wrapper">
      <button
        type="button"
        className={`dd-header ${extraBtnCss}`}
        onClick={handleToggle}
        disabled={disable}
      >
        <div className="dd-header-label">
          {fixedLabel ? label : optionSelected}{" "}
          {isOpen ? (
            <i className="bi bi-chevron-up"></i>
          ) : (
            <i className="bi bi-chevron-down"></i>
          )}
        </div>
      </button>
      {optionSelected !== label && remove && (
        <>
          <i className="bi bi-x-circle remove-icon" onClick={handleReset}></i>
        </>
      )}

      {isOpen && (
        <div className="dd-list shadow">
          <div className="absolute">
            {options ? options.map((option) => {
              return (
                <button
                  type="button"
                  className="dd-list-item"
                  key={option.id}
                  onClick={() => handleSelection(option)}
                >
                  {option[fieldToDisplay]}
                </button>
              );
            }) : "No Options Found"}
          </div>
        </div>
      )}
    </div>
  );
}

export default Dropdown;
